<template>
    <modal-dialog
        ref="contactEditModal"
        label="Gegevens bewerken"
        description="Hier kun je de gegevens van een contact en de partner aanpassen"
        without-padding
        :size="4"
    >
        <form-validation v-slot="{ bindings: validationBindings }">
            <flex-container :padding="Size.lg" :gap="Size.sm">
                <div>
                    <text-heading>
                        Gegevens bewerken
                    </text-heading>
                    <br>
                    <text-description>
                        Hier kun je de gegevens van een contact en de partner aanpassen
                    </text-description>
                </div>

                <inline-tabs :selected-name="tabContact">
                    <template #labels>
                        <inline-tab-label name="contact">
                            Contactpersoon
                        </inline-tab-label>

                        <inline-tab-label name="partner">
                            Partner
                        </inline-tab-label>
                    </template>

                    <template #panels>
                        <inline-tab-panel
                            name="contact"
                            with-variable-height
                        >
                            <text-heading sub>
                                Persoonsgegevens
                            </text-heading>

                            <div class="contact-card-personal-information">
                                <input-group
                                    v-model="primaryContactData.initials"
                                    :schema="createContactCommand.getValidationSchemaForField('initials')"
                                >
                                    <template #label>
                                        <input-label>
                                            Initialen
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="primaryContactData.firstName"
                                    :schema="createContactCommand.getValidationSchemaForField('firstName')"
                                >
                                    <template #label>
                                        <input-label>
                                            Voornaam
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="primaryContactData.middleName"
                                    :schema="createContactCommand.getValidationSchemaForField('middleName')"
                                >
                                    <template #label>
                                        <input-label>
                                            Tussenvoegsel
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="primaryContactData.lastName"
                                    :schema="createContactCommand.getValidationSchemaForField('lastName')"
                                >
                                    <template #label>
                                        <input-label>
                                            Achternaam
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="primaryContactData.gender"
                                    :schema="object({ value: createContactCommand.getValidationSchemaForField('gender') }).nullable()"
                                    class="contact-card-personal-information__gender"
                                >
                                    <template #label>
                                        <input-label>
                                            Geslacht
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <select-input :items="Gender.options" />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="primaryContactData.birthDate"
                                    :schema="createContactCommand.getValidationSchemaForField('birthDate')"
                                    class="contact-card-personal-information__birthDate"
                                >
                                    <template #label>
                                        <input-label>
                                            Geboortedatum
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <date-input type="date" clearable />
                                    </template>
                                </input-group>
                            </div>

                            <horizontal-line />

                            <text-heading sub>
                                Communicatie
                            </text-heading>

                            <div class="contact-card-communication-information">
                                <input-group
                                    v-model="primaryContactData.email"
                                    :schema="createContactCommand.getValidationSchemaForField('email')"
                                >
                                    <template #label>
                                        <input-label>
                                            E-mail adres
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="primaryContactData.mobilePhoneNumber"
                                    :schema="createContactCommand.getValidationSchemaForField('mobilePhoneNumber')"
                                >
                                    <template #label>
                                        <input-label>
                                            Mobiel tel.
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="primaryContactData.phoneNumber"
                                    :schema="createContactCommand.getValidationSchemaForField('phoneNumber')"
                                >
                                    <template #label>
                                        <input-label>
                                            Vast tel.
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>
                            </div>

                            <inline-tabs
                                class="contact-card-adres-information-tabs"
                                :selected-name="tabAddress"
                            >
                                <template #labels>
                                    <inline-tab-label name="address">
                                        Adres
                                    </inline-tab-label>

                                    <inline-tab-label name="future-address">
                                        Toekomstig adres
                                    </inline-tab-label>
                                </template>
                                <template #panels>
                                    <inline-tab-panel name="address">
                                        <div class="contact-card-adres-information">
                                            <input-group
                                                v-model="primaryContactData.postalCode"
                                                :schema="createContactCommand.getValidationSchemaForField('addressPostalCode')"
                                                class="contact-card-adres-information__postal-code"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Postcode
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input />
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.number"
                                                :schema="createContactCommand.getValidationSchemaForField('addressNumber')"
                                                class="contact-card-adres-information__number"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Huisnummer
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input />
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.numberSuffix"
                                                :schema="createContactCommand.getValidationSchemaForField('addressNumberSuffix')"
                                                class="contact-card-adres-information__number-suffix"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Toevoeging
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input />
                                                </template>
                                            </input-group>

                                            <button-outline
                                                :disabled="primaryPostcodeCheckLoading"
                                                class="contact-card-adres-information__search"
                                                @click="doPostcodeLookup(primaryContactData.postalCode, primaryContactData.number)"
                                            >
                                                Zoeken
                                            </button-outline>

                                            <input-group
                                                v-model="primaryContactData.street"
                                                :schema="createContactCommand.getValidationSchemaForField('addressStreet')"
                                                class="contact-card-adres-information__street"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Straatnaam
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input
                                                        :disabled="primaryPostcodeCheckLoading"
                                                    />
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.city"
                                                :schema="createContactCommand.getValidationSchemaForField('addressCity')"
                                                class="contact-card-adres-information__city"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Plaatsnaam
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input
                                                        :disabled="primaryPostcodeCheckLoading"
                                                    />
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.country"
                                                :schema="createContactCommand.getValidationSchemaForField('addressCountry')"
                                                class="contact-card-adres-information__country"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Land
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <select-input
                                                        :items="getCountryNames()"
                                                        :disabled="primaryPostcodeCheckLoading"
                                                    >
                                                        <template #active="{ bindings }">
                                                            <flex-container
                                                                v-if="bindings.value"
                                                                size="auto"
                                                                :gap="Size.sm"
                                                                align-items="center"
                                                                inline
                                                            >
                                                                <country-flag
                                                                    :country-code="getCountryCodeForName(bindings.value) as string"
                                                                    :size="IconSize.sm"
                                                                />
                                                                <span>{{ bindings.value }}</span>
                                                            </flex-container>
                                                            <span v-else>
                                                                Kies een land
                                                            </span>
                                                        </template>
                                                        <template #item="{ bindings }">
                                                            <flex-container
                                                                size="auto"
                                                                :gap="Size.sm"
                                                                align-items="center"
                                                                inline
                                                            >
                                                                <country-flag
                                                                    :country-code="getCountryCodeForName(bindings.item) as string"
                                                                    :size="IconSize.sm"
                                                                />
                                                                <span>{{ bindings.item }}</span>
                                                            </flex-container>
                                                        </template>
                                                    </select-input>
                                                </template>
                                            </input-group>
                                        </div>
                                    </inline-tab-panel>
                                    <inline-tab-panel name="future-address">
                                        <div class="contact-card-adres-information">
                                            <input-group
                                                v-model="primaryContactData.futureAddressPostalCode"
                                                :schema="createContactCommand.getValidationSchemaForField('futureAddressPostalCode')"
                                                class="contact-card-adres-information__postal-code"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Postcode
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input />
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.futureAddressNumber"
                                                :schema="createContactCommand.getValidationSchemaForField('futureAddressNumber')"
                                                class="contact-card-adres-information__number"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Huisnummer
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input />
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.futureAddressNumberSuffix"
                                                :schema="createContactCommand.getValidationSchemaForField('futureAddressNumberSuffix')"
                                                class="contact-card-adres-information__number-suffix"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Toevoeging
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input />
                                                </template>
                                            </input-group>

                                            <button-outline
                                                :disabled="futureAddressPostcodeCheckLoading"
                                                class="contact-card-adres-information__search"
                                                @click="doFutureAddressPostcodeLookup(
                                                    primaryContactData.futureAddressPostalCode,
                                                    primaryContactData.futureAddressNumber,
                                                )"
                                            >
                                                Zoeken
                                            </button-outline>

                                            <input-group
                                                v-model="primaryContactData.futureAddressStreet"
                                                :schema="createContactCommand.getValidationSchemaForField('futureAddressStreet')"
                                                class="contact-card-adres-information__street"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Straatnaam
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input
                                                        :disabled="futureAddressPostcodeCheckLoading"
                                                    />
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.futureAddressCity"
                                                :schema="createContactCommand.getValidationSchemaForField('futureAddressCity')"
                                                class="contact-card-adres-information__city"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Plaatsnaam
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <text-input
                                                        :disabled="futureAddressPostcodeCheckLoading"
                                                    />
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.futureAddressCountry"
                                                :schema="createContactCommand.getValidationSchemaForField('futureAddressCountry')"
                                                class="contact-card-adres-information__country"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Land
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <select-input
                                                        :items="getCountryNames()"
                                                        :disabled="futureAddressPostcodeCheckLoading"
                                                    >
                                                        <template #active="{ bindings }">
                                                            <flex-container
                                                                v-if="bindings.value"
                                                                size="auto"
                                                                :gap="Size.sm"
                                                                align-items="center"
                                                                inline
                                                            >
                                                                <country-flag
                                                                    :country-code="getCountryCodeForName(bindings.value) as string"
                                                                    :size="IconSize.sm"
                                                                />
                                                                <span>{{ bindings.value }}</span>
                                                            </flex-container>
                                                            <span v-else>
                                                                Kies een land
                                                            </span>
                                                        </template>
                                                        <template #item="{ bindings }">
                                                            <flex-container
                                                                size="auto"
                                                                :gap="Size.sm"
                                                                align-items="center"
                                                                inline
                                                            >
                                                                <country-flag
                                                                    :country-code="getCountryCodeForName(bindings.item) as string"
                                                                    :size="IconSize.sm"
                                                                />
                                                                <span>{{ bindings.item }}</span>
                                                            </flex-container>
                                                        </template>
                                                    </select-input>
                                                </template>
                                            </input-group>

                                            <input-group
                                                v-model="primaryContactData.futureAddressStartingDate"
                                                :schema="createContactCommand.getValidationSchemaForField('futureAddressStartingDate')"
                                                class="contact-card-adres-information__futureAddressStartingDate"
                                            >
                                                <template #label>
                                                    <input-label>
                                                        Vanaf datum
                                                    </input-label>
                                                </template>
                                                <template #input>
                                                    <date-input
                                                        clearable
                                                        type="date"
                                                        vertical-position="top-out"
                                                    />
                                                </template>
                                            </input-group>
                                        </div>
                                    </inline-tab-panel>
                                </template>
                            </inline-tabs>
                        </inline-tab-panel>

                        <inline-tab-panel
                            name="partner"
                            with-variable-height
                        >
                            <text-heading sub>
                                Persoonsgegevens
                            </text-heading>

                            <div class="contact-card-personal-information">
                                <input-group
                                    v-model="secondaryContactData.initials"
                                    :schema="createContactCommand.getValidationSchemaForField('initials')"
                                >
                                    <template #label>
                                        <input-label>
                                            Initialen
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.firstName"
                                    :schema="createContactCommand.getValidationSchemaForField('firstName')"
                                >
                                    <template #label>
                                        <input-label>
                                            Voornaam
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.middleName"
                                    :schema="createContactCommand.getValidationSchemaForField('middleName')"
                                >
                                    <template #label>
                                        <input-label>
                                            Tussenvoegsel
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.lastName"
                                    :schema="createContactCommand.getValidationSchemaForField('lastName')"
                                >
                                    <template #label>
                                        <input-label>
                                            Achternaam
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.gender"
                                    :schema="object({ value: createContactCommand.getValidationSchemaForField('gender') }).nullable()"
                                    class="contact-card-personal-information__gender"
                                >
                                    <template #label>
                                        <input-label>
                                            Geslacht
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <select-input :items="Gender.options" />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.birthDate"
                                    :schema="createContactCommand.getValidationSchemaForField('birthDate')"
                                    class="contact-card-personal-information__birthDate"
                                >
                                    <template #label>
                                        <input-label>
                                            Geboortedatum
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <date-input type="date" clearable />
                                    </template>
                                </input-group>
                            </div>

                            <horizontal-line />

                            <flex-container
                                align-items="center"
                                justify-content="space-between"
                            >
                                <text-heading sub>
                                    Communicatie
                                </text-heading>

                                <input-group
                                    v-model="secondaryContactHasCustomCommunicationFields"
                                    inline
                                >
                                    <template #input="{ bindings }">
                                        <flex-container align-items="center">
                                            <label :for="bindings.ids.input">
                                                <text-decorator
                                                    :size="FontSize.sm"
                                                    :color="Color.gray400"
                                                    bold
                                                >
                                                    Afwijkende gegevens?
                                                </text-decorator>
                                            </label>
                                            <toggle-input>
                                                <template #labelActive>
                                                    Ja
                                                </template>
                                                <template #labelInactive>
                                                    Nee
                                                </template>
                                            </toggle-input>
                                        </flex-container>
                                    </template>
                                </input-group>
                            </flex-container>

                            <div
                                v-show="secondaryContactHasCustomCommunicationFields"
                                class="contact-card-communication-information"
                            >
                                <input-group
                                    v-model="secondaryContactData.email"
                                    :schema="createContactCommand.getValidationSchemaForField('email')"
                                >
                                    <template #label>
                                        <input-label>
                                            E-mail adres
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.mobilePhoneNumber"
                                    :schema="createContactCommand.getValidationSchemaForField('mobilePhoneNumber')"
                                >
                                    <template #label>
                                        <input-label>
                                            Mobiel tel.
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.phoneNumber"
                                    :schema="createContactCommand.getValidationSchemaForField('phoneNumber')"
                                >
                                    <template #label>
                                        <input-label>
                                            Vast tel.
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>
                            </div>

                            <horizontal-line />

                            <flex-container
                                class="contact-card-adres-information-heading"
                                align-items="center"
                                justify-content="space-between"
                            >
                                <text-heading sub>
                                    Adres
                                </text-heading>

                                <input-group
                                    v-model="secondaryContactHasCustomAddressFields"
                                    inline
                                >
                                    <template #input="{ bindings }">
                                        <flex-container align-items="center">
                                            <label :for="bindings.ids.input">
                                                <text-decorator
                                                    :size="FontSize.sm"
                                                    :color="Color.gray400"
                                                    bold
                                                >
                                                    Afwijkende gegevens?
                                                </text-decorator>
                                            </label>
                                            <toggle-input>
                                                <template #labelActive>
                                                    Ja
                                                </template>
                                                <template #labelInactive>
                                                    Nee
                                                </template>
                                            </toggle-input>
                                        </flex-container>
                                    </template>
                                </input-group>
                            </flex-container>

                            <div
                                v-show="secondaryContactHasCustomAddressFields"
                                class="contact-card-adres-information"
                            >
                                <input-group
                                    v-model="secondaryContactData.postalCode"
                                    :schema="createContactCommand.getValidationSchemaForField('addressPostalCode')"
                                    class="contact-card-adres-information__postal-code"
                                >
                                    <template #label>
                                        <input-label>
                                            Postcode
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.number"
                                    :schema="createContactCommand.getValidationSchemaForField('addressNumber')"
                                    class="contact-card-adres-information__number"
                                >
                                    <template #label>
                                        <input-label>
                                            Huisnummer
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.numberSuffix"
                                    :schema="createContactCommand.getValidationSchemaForField('addressNumberSuffix')"
                                    class="contact-card-adres-information__number-suffix"
                                >
                                    <template #label>
                                        <input-label>
                                            Toevoeging
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input />
                                    </template>
                                </input-group>

                                <button-outline
                                    :disabled="secondaryPostcodeCheckLoading"
                                    class="contact-card-adres-information__search"
                                    @click="doPostcodeLookup(secondaryContactData.postalCode, secondaryContactData.number, true)"
                                >
                                    Zoeken
                                </button-outline>

                                <input-group
                                    v-model="secondaryContactData.street"
                                    :schema="createContactCommand.getValidationSchemaForField('addressStreet')"
                                    class="contact-card-adres-information__street"
                                >
                                    <template #label>
                                        <input-label>
                                            Straatnaam
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input
                                            :disabled="secondaryPostcodeCheckLoading"
                                        />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.city"
                                    :schema="createContactCommand.getValidationSchemaForField('addressCity')"
                                    class="contact-card-adres-information__city"
                                >
                                    <template #label>
                                        <input-label>
                                            Plaatsnaam
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input
                                            :disabled="secondaryPostcodeCheckLoading"
                                        />
                                    </template>
                                </input-group>

                                <input-group
                                    v-model="secondaryContactData.country"
                                    :schema="createContactCommand.getValidationSchemaForField('addressCountry')"
                                    class="contact-card-adres-information__country"
                                >
                                    <template #label>
                                        <input-label>
                                            Land
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <select-input
                                            :items="getCountryNames()"
                                            :disabled="secondaryPostcodeCheckLoading"
                                        >
                                            <template #active="{ bindings }">
                                                <flex-container
                                                    v-if="bindings.value"
                                                    size="auto"
                                                    :gap="Size.sm"
                                                    align-items="center"
                                                    inline
                                                >
                                                    <country-flag
                                                        :country-code="getCountryCodeForName(bindings.value) as string"
                                                        :size="IconSize.sm"
                                                    />
                                                    <span>{{ bindings.value }}</span>
                                                </flex-container>
                                                <span v-else>
                                                    Kies een land
                                                </span>
                                            </template>
                                            <template #item="{ bindings }">
                                                <flex-container
                                                    size="auto"
                                                    :gap="Size.sm"
                                                    align-items="center"
                                                    inline
                                                >
                                                    <country-flag
                                                        :country-code="getCountryCodeForName(bindings.item) as string"
                                                        :size="IconSize.sm"
                                                    />
                                                    <span>{{ bindings.item }}</span>
                                                </flex-container>
                                            </template>
                                        </select-input>
                                    </template>
                                </input-group>
                            </div>
                        </inline-tab-panel>
                    </template>
                </inline-tabs>
            </flex-container>

            <flex-container
                align-items="center"
                justify-content="flex-end"
                :color="Color.gray100"
                :padding="Size.md"
            >
                <button-outline @click="redirectToDetail">
                    Annuleren
                </button-outline>

                <button-block-confirm
                    :disabled="!validationBindings.isValid.value"
                    @confirmed="saveAndClose($event)"
                >
                    Opslaan

                    <template #confirmation>
                        Weet je het zeker?
                    </template>
                </button-block-confirm>
            </flex-container>
        </form-validation>
    </modal-dialog>
</template>

<script setup lang="ts">
    import {
        useCountries,
        CountryFlag,
        TextDescription,
        Color,
        Size,
        IconSize,
        type ExposedOverlay,
        ButtonBlockConfirm,
        InlineTabs,
        InlineTabLabel,
        InlineTabPanel,
        ButtonOutline,
        ModalDialog,
        TextHeading,
        TextDecorator,
        FlexContainer,
        FormValidation,
        InputLabel,
        TextInput,
        InputGroup,
        SelectInput,
        HorizontalLine,
        ToggleInput,
        FontSize,
        DateInput,
    } from '@keyvue/one-ui';

    import {
        UserAPI,
        ContactAPI,
        Contact as LegacyContact,
        ReferralAPI,
        Referral,
    } from '@keyvue/one-api-client-legacy';

    import { reactive, ref, watch } from 'vue';
    import { useRouter, useRoute, type RouteLocationRaw } from 'vue-router';
    import useClient from '@composables/useClient';
    import useOverlayAsRoute from '@composables/useOverlayAsRoute';
    import { CreateContactCommand, Gender, Contact } from '@keyvue/one-api-client';
    import { string, object } from 'yup';
    import PostcodeAPI from '@/utils/postcodeApi';
    import useEventBus from '@composables/useEventBus';

    interface Props {
        contactId: string;
    }

    const props = defineProps<Props>();

    const buildFromContact = (original?: Contact) => (ref<{
        initials: string | null
        firstName: string | null
        middleName: string | null
        lastName: string | null
        gender: { value: string | null, label: string | null } | null
        birthDate: Date | null
        email: string | null
        mobilePhoneNumber: string | null
        phoneNumber: string | null
        postalCode: string | null
        number: string | null
        numberSuffix: string | null
        street: string | null
        city: string | null
        country: string | null
        futureAddressStreet: string | null
        futureAddressNumber: string | null
        futureAddressNumberSuffix: string | null
        futureAddressPostalCode: string | null
        futureAddressCity: string | null
        futureAddressRegion: string | null
        futureAddressCountry: string | null
        futureAddressStartingDate: Date | null
    }>({
        initials: original?.name?.initials ?? null,
        firstName: original?.name?.firstName ?? null,
        middleName: original?.name?.middleName ?? null,
        lastName: original?.name?.lastName ?? null,
        gender: original?.gender ? ({
            value: original?.gender?.toString() ?? null,
            label: Gender.options.find(
                (option) => (option.value === original?.gender?.toString() ?? null),
            )?.label ?? null,
        }) : null,
        birthDate: original?.birthDate ? new Date(original?.birthDate) : null,
        email: original?.email?.toString() ?? null,
        mobilePhoneNumber: original?.mobilePhoneNumber?.toString() ?? null,
        phoneNumber: original?.phoneNumber?.toString() ?? null,
        postalCode: original?.address?.postalCode ?? null,
        number: original?.address?.number ?? null,
        numberSuffix: original?.address?.numberSuffix ?? null,
        street: original?.address?.street ?? null,
        city: original?.address?.city ?? null,
        country: original?.address?.country ?? null,
        futureAddressStreet: original?.futureAddress?.street ?? null,
        futureAddressNumber: original?.futureAddress?.number ?? null,
        futureAddressNumberSuffix: original?.futureAddress?.numberSuffix ?? null,
        futureAddressPostalCode: original?.futureAddress?.postalCode ?? null,
        futureAddressCity: original?.futureAddress?.city ?? null,
        futureAddressRegion: original?.futureAddress?.region ?? null,
        futureAddressCountry: original?.futureAddress?.country ?? null,
        futureAddressStartingDate: original?.futureAddressStartingDate ? new Date(original?.futureAddressStartingDate) : null,
    }));

    const eventBus = useEventBus();
    const router = useRouter();
    const route = useRoute();
    const { client, currentCompany } = useClient();
    const { getCountryNames, getCountryCodeForName, getCountryNameForCode } = useCountries();
    const contactEditModal = ref<ExposedOverlay>();
    const postalCodeSchema = string().matches(/^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i, 'Ongeldige postcode');

    const contact = reactive(await client.get(Contact, props.contactId)) as Contact;
    if (!contact.company && currentCompany.value) {
        contact.company = currentCompany.value;
    }

    const createContactCommand = CreateContactCommand.fromContact(contact);
    const primaryContactData = buildFromContact(contact);
    const primaryPostcodeCheckLoading = ref(false);
    const primaryPostcodeCheckHasResult = ref(false);
    const futureAddressPostcodeCheckLoading = ref(false);
    const futureAddressPostcodeCheckHasResult = ref(false);
    const secondaryContactData = buildFromContact(contact.secondaryContact ?? undefined);
    const secondaryPostcodeCheckLoading = ref(false);
    const secondaryPostcodeCheckHasResult = ref(false);
    const secondaryContactHasCustomAddressFields = ref(!!secondaryContactData.value.street);
    const secondaryContactHasCustomCommunicationFields = ref(!!secondaryContactData.value.email);

    const doPostcodeLookup = async (postalCode: string | null, number: number | string | null, secondaryContact = false) => {
        if (secondaryContact) {
            secondaryPostcodeCheckLoading.value = true;
            secondaryPostcodeCheckHasResult.value = false;
        } else {
            primaryPostcodeCheckLoading.value = true;
            primaryPostcodeCheckHasResult.value = false;
        }

        try {
            await postalCodeSchema.validate(postalCode);
        } catch (e) {
            if (secondaryContact) {
                secondaryPostcodeCheckLoading.value = false;
                secondaryPostcodeCheckHasResult.value = false;
            } else {
                primaryPostcodeCheckLoading.value = false;
                primaryPostcodeCheckHasResult.value = false;
            }

            return;
        }

        if (!postalCode || !number) {
            return;
        }

        if (postalCode.length < 6 || String(number).length < 1) {
            return;
        }

        let result;

        try {
            result = await PostcodeAPI.lookup(postalCode, number);
        } catch (e) {
            if (secondaryContact) {
                secondaryPostcodeCheckLoading.value = false;
                secondaryPostcodeCheckHasResult.value = false;
            } else {
                primaryPostcodeCheckLoading.value = false;
                primaryPostcodeCheckHasResult.value = false;
            }

            return;
        }

        if (secondaryContact) {
            secondaryPostcodeCheckHasResult.value = true;
        } else {
            primaryPostcodeCheckHasResult.value = true;
        }

        const contactData = secondaryContact ? secondaryContactData : primaryContactData;

        if (result.postcode) {
            contactData.value.postalCode = result.postcode;
        }

        if (result.street) {
            contactData.value.street = result.street;
        }

        if (result.number) {
            contactData.value.number = String(result.number);
        }

        if (result.letter) {
            contactData.value.numberSuffix = result.letter;
        }

        if (result.addition) {
            contactData.value.numberSuffix = result.addition;
        }

        if (result.city.label) {
            contactData.value.city = result.city.label;

            // PostcodeAPI only does dutch addresses, so set if empty
            if (!contactData.value.country) {
                contactData.value.country = getCountryNameForCode('nl') ?? null;
            }
        }

        if (secondaryContact) {
            secondaryPostcodeCheckLoading.value = false;
        } else {
            primaryPostcodeCheckLoading.value = false;
        }
    };

    const doFutureAddressPostcodeLookup = async (postalCode: string | null, number: number | string | null) => {
        futureAddressPostcodeCheckLoading.value = true;
        futureAddressPostcodeCheckHasResult.value = false;

        try {
            await postalCodeSchema.validate(postalCode);
        } catch (e) {
            futureAddressPostcodeCheckLoading.value = false;
            futureAddressPostcodeCheckHasResult.value = false;
            return;
        }

        if (!postalCode || !number) {
            return;
        }

        if (postalCode.length < 6 || String(number).length < 1) {
            return;
        }

        let result;

        try {
            result = await PostcodeAPI.lookup(postalCode, number);
        } catch (e) {
            futureAddressPostcodeCheckLoading.value = false;
            futureAddressPostcodeCheckHasResult.value = false;
            return;
        }

        futureAddressPostcodeCheckHasResult.value = true;

        if (result.postcode) {
            primaryContactData.value.futureAddressPostalCode = result.postcode;
        }

        if (result.street) {
            primaryContactData.value.futureAddressStreet = result.street;
        }

        if (result.number) {
            primaryContactData.value.futureAddressNumber = String(result.number);
        }

        if (result.letter) {
            primaryContactData.value.futureAddressNumberSuffix = result.letter;
        }

        if (result.addition) {
            primaryContactData.value.futureAddressNumberSuffix = result.addition;
        }

        if (result.city.label) {
            primaryContactData.value.futureAddressCity = result.city.label;

            // PostcodeAPI only does dutch addresses, so set if empty
            if (!primaryContactData.value.futureAddressCountry) {
                primaryContactData.value.futureAddressCountry = getCountryNameForCode('nl') ?? null;
            }
        }

        futureAddressPostcodeCheckLoading.value = false;
    };

    const saveInLegacy = async () => {
        const updatedLegacyContact = LegacyContact.fromData({
            ...await ContactAPI.get(contact.id.toString()),
            company: UserAPI.currentUser?.company?.resourceIdentifier,
            gender: primaryContactData.value.gender?.value,
            initials: primaryContactData.value.initials,
            firstname: primaryContactData.value.firstName,
            middlename: primaryContactData.value.middleName,
            lastname: primaryContactData.value.lastName,
            streetname: primaryContactData.value.street,
            streetnumber: primaryContactData.value.number,
            streetnumbersuffix: primaryContactData.value.numberSuffix,
            zipcode: primaryContactData.value.postalCode,
            city: primaryContactData.value.city,
            country: primaryContactData.value.country,
            birthDate: primaryContactData.value.birthDate,
            email: primaryContactData.value.email,
            mobilePhonenumber: primaryContactData.value.mobilePhoneNumber,
            phonenumber: primaryContactData.value.phoneNumber,
            spouse: !!secondaryContactData.value.firstName || !!secondaryContactData.value.lastName,
            spouseGender: secondaryContactData.value.gender?.value,
            spouseInitials: secondaryContactData.value.initials,
            spouseFirstname: secondaryContactData.value.firstName,
            spouseMiddlename: secondaryContactData.value.middleName,
            spouseLastname: secondaryContactData.value.lastName,
            spouseHasCustomAddress: secondaryContactHasCustomAddressFields.value,
            spouseStreetname: secondaryContactData.value.street,
            spouseStreetnumber: secondaryContactData.value.number,
            spouseStreetnumbersuffix: secondaryContactData.value.numberSuffix,
            spouseZipcode: secondaryContactData.value.postalCode,
            spouseCity: secondaryContactData.value.city,
            spouseCountry: secondaryContactData.value.country,
            spouseLatitude: null,
            spouseLongitude: null,
            spouseBirthDate: secondaryContactData.value.birthDate,
            spouseHasCustomContactDetails: secondaryContactHasCustomCommunicationFields.value,
            spouseEmail: secondaryContactData.value.email,
            spouseMobilePhonenumber: secondaryContactData.value.mobilePhoneNumber,
            spousePhonenumber: secondaryContactData.value.phoneNumber,
        });

        await ContactAPI.update(updatedLegacyContact.id, updatedLegacyContact);

        const referrals = await ReferralAPI.getAll({
            contact: props.contactId,
            'order[createdAt]': 'desc',
            itemsPerPage: 1,
        });

        const latestReferral = referrals[0];
        if (latestReferral) {
            await ReferralAPI.update(latestReferral.id, {
                ...latestReferral,
                futureStreetname: primaryContactData.value?.futureAddressStreet,
                futureStreetnumber: primaryContactData?.value.futureAddressNumber,
                futureStreetnumbersuffix: primaryContactData?.value.futureAddressNumberSuffix,
                futureZipcode: primaryContactData?.value.futureAddressPostalCode,
                futureCity: primaryContactData?.value.futureAddressCity,
                futureCountry: primaryContactData?.value.futureAddressCountry,
                futureFrom: primaryContactData?.value.futureAddressStartingDate,
            } as Referral);
        }
    };

    const redirectToDetail = () => {
        const detailRoute: RouteLocationRaw = {
            name: 'contactDetail',
            params: {
                contactId: contact.id.toString(),
            },
        };

        if ('leadId' in route.params) {
            detailRoute.name = 'contactLeadDetail';
            detailRoute.params = {
                ...detailRoute.params,
                leadId: route.params.leadId.toString(),
            };
        }

        if ('orderId' in route.params) {
            detailRoute.name = 'contactOrderDetail';
            detailRoute.params = {
                ...detailRoute.params,
                orderId: route.params.orderId.toString(),
            };
        }

        router.push(detailRoute);
    };

    const saveAndClose = async (event: any) => {
        await saveInLegacy();

        eventBus.dispatch<string>('resource-manipulated', 'Contact');

        event.button.setState('completed');
        redirectToDetail();
    };

    useOverlayAsRoute({
        overlay: contactEditModal,
        isSideSheet: false,
        redirectMethod: redirectToDetail,
    });

    watch(contact, () => {
        primaryContactData.value = buildFromContact(contact).value;
        secondaryContactData.value = buildFromContact(contact.secondaryContact ?? undefined).value;
    });

    watch(secondaryContactHasCustomCommunicationFields, () => {
        if (!secondaryContactHasCustomCommunicationFields.value) {
            secondaryContactData.value.email = null;
            secondaryContactData.value.mobilePhoneNumber = null;
            secondaryContactData.value.phoneNumber = null;
        }
    });

    watch(secondaryContactHasCustomAddressFields, () => {
        if (!secondaryContactHasCustomAddressFields.value) {
            secondaryContactData.value.postalCode = null;
            secondaryContactData.value.number = null;
            secondaryContactData.value.numberSuffix = null;
            secondaryContactData.value.street = null;
            secondaryContactData.value.city = null;
            secondaryContactData.value.country = null;
        }
    });

    // Allow query param to control tab visibility
    const tabContact = ref(route.query.contact === 'partner'
        ? 'partner'
        : 'contact');
    const tabAddress = ref(route.query.address === 'future-address'
        ? 'future-address'
        : 'address');
</script>

<style lang="scss" scoped>
.contact-card-personal-information,
.contact-card-adres-information,
.contact-card-communication-information {
    display: grid;
    max-width: 100%;
    gap: size(md);
    padding-right: size(xs);
    padding-top: size(sm);
    grid-auto-rows: max-content;
}

.contact-card-personal-information {
    grid-template-columns: 1fr 3fr 2fr 3fr;

    &__gender {
        grid-column: 1 / span 2;
    }

    &__birthDate {
        grid-column: 3 / span 2;
    }
}

.contact-card-communication-information {
    grid-template-columns: 2fr 1fr 1fr;
}

.contact-card-adres-information-tabs {
    padding-top: size(md);
}

.contact-card-adres-information-heading {
    padding-bottom: size(sm);
}

.contact-card-adres-information {
    grid-template-columns: repeat(20, 1fr);
    padding-top:0;

    &__postal-code {
        grid-column: 1/ 7;
    }

    &__number {
        grid-column: 7/ 11;
    }

    &__number-suffix {
        grid-column: 11/ 14;
    }

    &__search {
        grid-column: 14/ 18;
        align-self: flex-end;
    }

    &__street {
        grid-column: 1/ 10;
        grid-row: 2/3;
    }

    &__city {
        grid-column: 10/ 20;
        grid-row: 2/3;
    }

    &__country {
        grid-column: 1/8;
        grid-row: 3/4;
    }

    &__futureAddressStartingDate {
        grid-column: span 12;
        grid-row: 3/4;
    }
}
</style>
